import React from 'react';
import { Input, Spinner } from 'reactstrap';
import { useAllItemTypesQuery } from '../../graphql/queries/allItemTypes.generated';
import i18n from '@/utils/i18n';
import { ItemTypeCategory } from '@/graphql/generatedTypes';

interface ItemTypeSelectorProps {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  placeholder?: string;
}

const ItemTypeSelector: React.FC<ItemTypeSelectorProps> = ({
  value,
  onChange,
  disabled = false,
  placeholder,
}) => {
  const { data: itemTypes, loading: loadingItemTypes } = useAllItemTypesQuery({
    variables: {
      filter: {
        category: ItemTypeCategory.Asset,
        archived: false,
      },
      skip: 0,
      take: 100,
    },
  });

  if (loadingItemTypes) {
    return (
      <div className="d-flex align-items-center">
        <Spinner size="sm" className="me-2" />
        {i18n.t('Common:loading')}...
      </div>
    );
  }

  return (
    <Input
      type="select"
      value={value}
      disabled={disabled || loadingItemTypes}
      onChange={(e) => onChange(e.target.value)}
    >
      <option value="" disabled>
        {placeholder || i18n.t('TrackableItems:selectItemType')}
      </option>
      {(itemTypes?.itemTypes.items || []).map((itemType) => (
        <option key={itemType.id} value={itemType.id}>
          {itemType.name}
        </option>
      ))}
    </Input>
  );
};

export default ItemTypeSelector;
